module.exports = __webpack_public_path__ + "static/media/sign-up-image.ce356b05.jpg";